import { select } from 'd3-selection';
import getRotatedDimension from './get-rotated-dimension';
import createElementIdSelector from './create-element-id-selector';
import { Orientation } from '../../../types';
var calculateAxisDimension = function (_a) {
    var axisTheme = _a.axisTheme, axisTitle = _a.axisTitle, svgElement = _a.svgElement, orientation = _a.orientation;
    var axisEnabled = axisTheme.enabled, padding = axisTheme.padding, tickSize = axisTheme.tickSize, tickPadding = axisTheme.tickPadding, titlePadding = axisTheme.title.padding, _b = axisTheme.labels, labelsEnabled = _b.enabled, radiusAngle = _b.radiusAngle;
    var rootContainer = select(svgElement);
    var labelsSelector = createElementIdSelector(orientation + "-ruler-label");
    var titleSelector = createElementIdSelector(orientation + "-axis-title");
    var maxLabel = '';
    var longestNode = null;
    rootContainer
        .selectAll(labelsSelector)
        .nodes()
        .forEach(function (node) {
        var labelElement = select(node);
        var text = labelElement.text();
        if (text.length > maxLabel.length) {
            maxLabel = text;
            longestNode = node;
        }
    });
    var textDimension = longestNode
        ? longestNode.getBBox()
        : {
            width: 0,
            height: 0,
        };
    var dimension = { width: 0, height: 0 };
    if (axisEnabled && labelsEnabled) {
        dimension = getRotatedDimension({ radiusAngle: radiusAngle, dimension: textDimension });
    }
    if (axisTitle) {
        var titleElement = rootContainer.select(titleSelector);
        var titleNode = titleElement && titleElement.node();
        var titleBbox = titleNode
            ? titleNode.getBBox()
            : {
                width: 0,
                height: 0,
            };
        if (orientation === Orientation.VERTICAL) {
            dimension = {
                height: dimension.height,
                width: dimension.width + titleBbox.height + titlePadding,
            };
        }
        else {
            dimension = {
                width: dimension.width,
                height: dimension.height + titleBbox.height + titlePadding,
            };
        }
    }
    if (axisEnabled) {
        var width = dimension.width, height = dimension.height;
        if (orientation === Orientation.VERTICAL) {
            dimension = {
                width: width + tickSize + tickPadding + padding,
                height: height,
            };
        }
        else {
            dimension = {
                width: width,
                height: height +
                    Math.abs(tickSize + tickPadding - textDimension.height) +
                    padding,
            };
        }
    }
    return dimension;
};
export default calculateAxisDimension;
